import { render } from "./SearchRow.vue?vue&type=template&id=c8dfc7c6&scoped=true"
import script from "./SearchRow.vue?vue&type=script&lang=js"
export * from "./SearchRow.vue?vue&type=script&lang=js"

import "./SearchRow.vue?vue&type=style&index=0&id=c8dfc7c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8dfc7c6"]])

export default __exports__